import ImgContainer from "components/common/img";
import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { getFormattedContactNumber, hasPermission } from "utility/helpers";
import { CellText, StyledEditIcon, StyledTrashIcon } from "assets/js/Styles";
import styled from "styled-components";

const PhotoFrame = styled.div`
  width: 50px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const senatorColumns = ({
  userImage,
  partyList,
  navigate,
  handleDeleteAction,
}) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "",
      selector: ({ photo }) => photo,
      grow: 0,
      minWidth: "80px",
      sortable: false,
      style: { paddingTop: "0.5rem", paddingBottom: "0.5rem" },
      cell: ({ photo }) => (
        <PhotoFrame>
          <ImgContainer
            alt="cong-image"
            src={photo || userImage}
            width="50px"
          />
        </PhotoFrame>
      ),
    },
    {
      name: "Name",
      selector: (row) => row?.fullName,
      identifier: "fullName",
      grow: 2,
      sortable: true,
      cell: ({ fullName }) => <CellText>{fullName}</CellText>,
    },
    {
      name: "Party",
      selector: ({ partyId }) => partyId,
      identifier: "partyId",
      grow: 2,
      sortable: true,
      cell: ({ partyId }) => (
        <CellText>
          {partyList.find((party) => party.id === partyId)?.acronym}
        </CellText>
      ),
    },
    {
      name: "Contact Info",
      selector: ({ contact }) => contact,
      identifier: "contact",
      grow: 2,
      sortable: true,
      cell: ({ contact }) => (
        <CellText>{getFormattedContactNumber(contact)}</CellText>
      ),
    },
    {
      name: "COS",
      selector: ({ cosName }) => cosName,
      identifier: "cosName",
      grow: 2,
      sortable: true,
      cell: ({ cosName, cosFirstName, cosLastName }) => (
        <CellText>
          {cosFirstName && cosLastName
            ? `${cosFirstName} ${cosLastName}`
            : cosName || ""}
        </CellText>
      ),
    },
    {
      name: "Contact Info",
      selector: ({ cosContact }) => cosContact,
      identifier: "cosContact",
      grow: 2,
      sortable: true,
      cell: ({ cosContact }) => (
        <CellText>{getFormattedContactNumber(cosContact)}</CellText>
      ),
    },
    {
      name: "Action",
      selector: (row) => row?.id,
      sortable: false,
      width: "100px",
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (row) => (
        <>
          {hasPermission("official-update") && (
            <>
              <StyledEditIcon
                size={16}
                id={`edit-row--${row.id}`}
                onClick={() => {
                  navigate("/sen", {
                    state: {
                      senator: row,
                    },
                  });
                }}
              />
              <UncontrolledTooltip
                placement="auto"
                target={`edit-row--${row.id}`}
              >
                {"Edit"}
              </UncontrolledTooltip>
            </>
          )}

          {hasPermission("official-delete") && (
            <>
              <StyledTrashIcon
                size={16}
                id={`delete-row--${row.id}`}
                onClick={() => handleDeleteAction(row)}
              />
              <UncontrolledTooltip
                placement="right"
                target={`delete-row--${row.id}`}
              >
                {"Delete"}
              </UncontrolledTooltip>
            </>
          )}
        </>
      ),
    },
  ];
};

export default senatorColumns;
